// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fee-container {
  max-width: 700px;
  margin: 0 auto;
  padding: 24px 16px;
}

.fee-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 24px;
  color: #333;
}

.fee-card {
  background: #fff;
  border-radius: 12px;
  padding: 28px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
}

.current-fee-section h5,
.new-fee-section h5 {
  font-weight: 600;
  margin-bottom: 12px;
  color: #444;
}

.current-fee-display {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.fee-badge {
  display: inline-block;
  background: #198754;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  padding: 6px 20px;
  border-radius: 50px;
  letter-spacing: 0.5px;
}

.fee-badge--unset {
  background: #6c757d;
  font-size: 1rem;
}

.fee-description {
  color: #666;
  font-size: 0.9rem;
  max-width: 380px;
}

.input-group-custom .form-label {
  margin-bottom: 6px;
}

.unit-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: #555;
}

.fee-preview {
  font-size: 0.85rem;
}

.info-section ul {
  padding-left: 18px;
  line-height: 1.8;
}

.loading-state {
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/set-credit-card-fee/set-credit-card-fee.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".fee-container {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 24px 16px;\n}\n\n.fee-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 24px;\n  color: #333;\n}\n\n.fee-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 28px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e9ecef;\n}\n\n.current-fee-section h5,\n.new-fee-section h5 {\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #444;\n}\n\n.current-fee-display {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.fee-badge {\n  display: inline-block;\n  background: #198754;\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 700;\n  padding: 6px 20px;\n  border-radius: 50px;\n  letter-spacing: 0.5px;\n}\n\n.fee-badge--unset {\n  background: #6c757d;\n  font-size: 1rem;\n}\n\n.fee-description {\n  color: #666;\n  font-size: 0.9rem;\n  max-width: 380px;\n}\n\n.input-group-custom .form-label {\n  margin-bottom: 6px;\n}\n\n.unit-label {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #555;\n}\n\n.fee-preview {\n  font-size: 0.85rem;\n}\n\n.info-section ul {\n  padding-left: 18px;\n  line-height: 1.8;\n}\n\n.loading-state {\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
